"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    title: "User Info",
    bordered: true
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    label: "Product"
  }, "Cloud Database"), /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    label: "Billing Mode"
  }, "Prepaid"), /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    label: "Automatic Renewal"
  }, "YES"), /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    label: "Order time"
  }, "2018-04-24 18:00:00"));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorSplit', 'colorText', 'colorFillAlter'],
  key: 'default'
};
var _default = exports.default = componentDemo;